<!-- eslint-disable vue/attribute-hyphenation -->
<template #chatSlot>
  <div class="container-chat">
    <div ref="chatContainer">
      <vue-advanced-chat
        :current-user-id="currentUserId"
        :rooms="JSON.stringify(rooms)"
        :rooms-loaded="true"
        :messages="JSON.stringify(messages)"
        :messages-loaded="messagesLoaded"
        :show-add-room="false"
        :show-audio="'false'"
        :single-room="true"
        :show-files="'false'"
        :show-emojis="'false'"
        :room-info-enabled="false"
        :auto-scroll="JSON.stringify(autoScroll)"
        :message-actions="[]"
        :show-reaction-emojis="'false'"
        :styles="JSON.stringify(styles)"
        :height="'100%'"
        :text-messages="JSON.stringify(textMessages)"
        class="custom-chat"
        @send-message="sendMessage($event)"
        @fetch-messages="fetchMessages()"
      >
        <div
          slot="room-header"
          class="header-container"
        >
          <div class="header">
            <v-icon class="bell-icon">
              mdi-bell
            </v-icon>
            {{ $t("gpt.betaMessage") }}
          </div>
        </div>
        <div
          v-if="isFeatureActive"
          slot="messages-empty"
        />
        <div
          v-else
          slot="messages-empty"
        >
          {{ $t("gpt.backgroundMessageNotActive") }}
        </div>

        <div
          v-for="message in messages"
          :slot="'message_' + message._id"
          :key="message._id"
        >
          <div
            v-if="message.avatar"
            :slot="'message-avatar_' + message._id"
            class="vac-avatar-container"
          >
            <div
              class="vac-avatar"
              :style="{ 'background-image': `url('${message.avatar}')` }"
            />
            <div class="vac-avatar-text">
              Aquassist GPT
            </div>
          </div>
          <div
            :class="
              message.senderId == AI_ID
                ? isBotTyping && !message.content
                  ? ''
                  : 'gpt-message'
                : 'user-message'
            "
            v-html="message.content"
          />
          <div
            v-if="isBotTyping && message.senderId == AI_ID && !message.content"
          >
            <div class="typing-indicator">
              <div class="dot" />
              <div class="dot" />
              <div class="dot" />
            </div>
          </div>
        </div>
      </vue-advanced-chat>
    </div>
  </div>
</template>

<script>
import { register } from 'vue-advanced-chat';
import Mutations from '@/helpers/graphql/mutations';
import Subscriptions from '@/helpers/graphql/subscriptions';
import GraphQLSubscriptionClient from '@/helpers/graphql/graphql_subscription_client';
// eslint-disable-next-line import/no-extraneous-dependencies
import { v4 as uuidv4 } from 'uuid';
import { mapGetters, mapActions } from 'vuex';
// TODO UNCOMMENT HERE WHEN WE ARE READY TO GET OUT OF BETA AND CHARGE FOR THIS FEATURE AQ-8904
// import {isFeatureActiveForTeam} from '@/utilities/featureValidator';
// import { TYPE_GENAI } from '@/aquassist-shared/constants/types/features';
import aqChatImage from '@/assets/images/chat_bubble.svg';
import aquassistIcon from '@/assets/images/aquassist-icon.svg';
// This is for the id of the bot and the user. The plugin requires them to work
const AI_ID = '1234';
const USER_ID = '4321';
register();
export default {
    data() {
        return {
            AI_ID,
            USER_ID,
            chatId: 1,
            // TODO CHANGE HERE TO FALSE WHEN WE ARE READY TO GET OUT OF BETA AND CHARGE FOR THIS FEATURE AQ-8904
            isFeatureActive: true,
            autoScroll: {
                send: {
                    new: true,
                    newAfterScrollUp: false,
                },
                receive: {
                    new: true,
                    newAfterScrollUp: true,
                },
            },
            modelParams: {
                embeddings_model: {
                    modelId: 'amazon.titan-embed-text-v2:0',
                    provider: 'Bedrock',
                    streaming: true,
                },
                qa_model: {
                    modelId: 'us.meta.llama3-3-70b-instruct-v1:0',
                    provider: 'Bedrock',
                    streaming: true,
                },
                retrieval: {
                    max_docs: 5,
                    index_name: '',
                    filter_filename: '',
                },
                verbose: false,
                responseGenerationMethod: 'RAG',
            },
            messagesLoaded: false,
            currentUserNickname: '',
            currentUserId: USER_ID,
            webSocket: null,
            currentRoomId: '1',
            rooms: [
                {
                    roomId: '1',
                    roomName: 'Aquassist GPT 1.0',

                    index: 3,
                    lastMessage: {},
                    users: [
                        {
                            _id: AI_ID,
                            username: 'GPT',
                            avatar: aquassistIcon,
                            status: {
                                state: 'online',
                            },
                        },
                        {
                            _id: USER_ID,
                            username: 'User',
                            status: {
                                state: 'online',
                            },
                        },
                    ],
                },
            ],
            messages: [],
            styles: {
                general: {
                    color: '#000',
                    borderStyle: 'none',
                },
                content: {
                    background: '#fff',
                },
                footer: {
                    background: '#fff',
                    color: '#000',
                    border: '1px solid #e1e4e8',
                },
                room: {
                    colorMessage: '#fff',
                },
                container: {
                    border: 'none',
                    borderRadius: '4px',
                    boxShadow:
            '0px 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px 0px rgba(0, 0, 0, 0)',
                },
                message: {
                    backgroundMe: '#1976d2',
                    colorMe: '#fff',
                    background: '#fff',
                    color: '#0a0a0a',
                },
            },
            isBotTyping: false,
            features: [],
        };
    },
    computed: {
        ...mapGetters(['team']),
        textMessages() {
            return {
                CONVERSATION_STARTED: this.$t('gpt.chatLabels.convesationStarted'),
                TYPE_MESSAGE: this.$t('gpt.chatLabels.typeMessage'),
            };
        },
    },
    async created() {
        // TODO UNCOMMENT HERE WHEN WE ARE READY TO GET OUT OF BETA AND CHARGE FOR THIS FEATURE AQ-8904
        // await this.getFeatures();
        // this.isFeatureActive = isFeatureActiveForTeam(
        //     this.team,
        //     this.features,
        //     TYPE_GENAI,
        // );
    },
    mounted() {
        const queryParams = new URLSearchParams(window.location.search);
        const isPopUp = queryParams.get('chatWindow');
        if (isPopUp) {
            document.querySelector('.custom-chat').style.height = '100vh';
            window.addEventListener('beforeunload', () => {
                this.saveChatHistory();
            });
        }
        this.webSocket = new GraphQLSubscriptionClient(
            process.env.VUE_APP_GRAPHQL_ENDPOINT,
            window.$cookies.get('accessToken'),
        );
        const date = new Date();
        const formattedDate = new Intl.DateTimeFormat(this.$i18n.locale, { dateStyle: 'full' }).format(date);
        this.messages.push({
            content: this.$t('gpt.initialMessage'),
            username: 'Aquassist GPT',
            avatar: aqChatImage,
            _id: this.chatId += 1,
            senderId: AI_ID,
            date: formattedDate,
            timestamp: date.toLocaleTimeString(),
            seen: true,
        });
    },
    beforeDestroy() {
        this.saveChatHistory();
        window.removeEventListener('resize', this.updateHeaderWidth);
    },
    methods: {
        ...mapActions({
            getFeaturesInfo: 'getFeaturesInfo',
        }),
        async getFeatures() {
            await this.getFeaturesInfo();
            const { features } = this.$store.state.features;
            this.features = features;
        },
        attachFileClickListeners() {
            const links = this.$el.querySelectorAll('.file-link');
            links.forEach(link => {
                link.addEventListener('click', event => {
                    event.preventDefault();
                    const filePath = link.getAttribute('data-filepath');
                    this.handleFileClick(filePath);
                });
            });
        },
        handleFileClick(filePath) {
            this.downloadFile(filePath);
        },
        async downloadFile(filePath) {
            const response = await this.$rq.downloadGPTFile(filePath);
            const blob = new Blob([response.data], { type: 'application/pdf' });
            this.$utils.saveFileOnDisk(blob, filePath);
        },
        decodeBase64(base64Str) {
            const binaryString = atob(base64Str);
            const byteArray = new Uint8Array(binaryString.length);
            for (let i = 0; i < binaryString.length; i += 1) {
                byteArray[i] = binaryString.charCodeAt(i);
            }
            const decodedString = new TextDecoder().decode(byteArray);
            return decodedString;
        },
        addMessage(message) {
            const status = message.payload.data.updateQAJobStatus.jobstatus;
            if (status === 'New LLM token') {
                this.isBotTyping = false;
                const decodedAnswer = this.decodeBase64(
                    message.payload.data.updateQAJobStatus.answer,
                );
                const messageIndex = this.messages.length - 1;
                const currentContent = this.messages[messageIndex].content || '';
                this.messages[messageIndex].content = this.formatContent(currentContent + decodedAnswer);
            } else if (status === 'Done' && this.messages[this.messages.length - 1].content === '') {
                const decodedAnswer = atob(message.payload.data.updateQAJobStatus.answer);
                const messageIndex = this.messages.length - 1;
                this.messages[messageIndex].content = this.formatContent(decodedAnswer);
            } else if (status === 'Done') {
                const messageIndex = this.messages.length - 1;
                const fileRegex = /\/[\w-]+\/[\w\s-]+\.[a-zA-Z]{3,4}/g;
                const updatedContent = this.messages[messageIndex].content.replace(
                    fileRegex,
                    match => `<a href="#" style="color:#ffffff;" class="file-link" data-filepath="${match}">${match}</a>`,
                );
                this.messages[messageIndex].content = updatedContent;
                this.$nextTick(() => {
                    this.attachFileClickListeners();
                });
                this.webSocket.unsubscribe();
            }
        },

        formatContent(content) {
            const formattedContent = content
                .replace(/\n/g, '<br>')
                .replace(/(\*{1,2})(.*?)\1/g, '<b>$2</b>')
                .replace(/`([^`]+)`/g, '<code>$1</code>');

            return formattedContent;
        },

        async fetchMessages() {
            this.messagesLoaded = false;
            setTimeout(() => {
                const messageHistory = JSON.parse(window.localStorage.getItem('chatHistory'));
                if (messageHistory) {
                    // eslint-disable-next-line no-underscore-dangle
                    this.chatId = messageHistory[messageHistory.length - 1]._id + 1;
                    this.messages = messageHistory;
                    window.localStorage.removeItem('chatHistory');
                }
                this.messagesLoaded = true;
            });
        },
        async sendMessage(event) {
            const question = event.detail[0].content;
            const date = new Date();
            const formattedDate = new Intl.DateTimeFormat(this.$i18n.locale, { dateStyle: 'full' }).format(date);
            this.messages.push({
                content: question,
                _id: this.chatId += 1,
                senderId: USER_ID,
                date: formattedDate,
                timestamp: date.toLocaleTimeString(),
                new: false,
            });
            const utf8EncodedQuestion = new TextEncoder().encode(question);
            const base64EncodedQuestion = btoa(
                String.fromCharCode.apply(null, utf8EncodedQuestion),
            );
            const encodedQuestion = base64EncodedQuestion;
            const jobid = uuidv4().substring(0, 10);
            this.webSocket.subscribe(
                Subscriptions.UPDATE_QA_JOB_STATUS,
                'UpdateQAJobStatus',
                {
                    jobid,
                },
                this.addMessage,
            );
            await this.askQuestion(encodedQuestion, jobid);
        },
        async askQuestion(encodedQuestion, jobid) {
            try {
                const variables = {
                    embeddings_model: this.modelParams.embeddings_model,
                    jobid,
                    jobstatus: '',
                    qa_model: this.modelParams.qa_model,
                    retrieval: this.modelParams.retrieval,
                    verbose: this.modelParams.verbose,
                    question: encodedQuestion,
                    responseGenerationMethod: this.modelParams.responseGenerationMethod,
                };
                this.isBotTyping = true;
                const date = new Date();
                const formattedDate = new Intl.DateTimeFormat(this.$i18n.locale, { dateStyle: 'full' }).format(date);
                this.messages.push({
                    content: '',
                    username: 'Aquassist GPT',
                    avatar: aqChatImage,
                    _id: this.chatId += 1,
                    senderId: AI_ID,
                    date: formattedDate,
                    timestamp: date.toLocaleTimeString(),
                    seen: true,
                });
                await this.$apollo.mutate({
                    mutation: Mutations.POST_QUESTION,
                    variables,
                });
            } catch (e) {
                this.error = e;
                console.error(e);
            }
        },
        saveChatHistory() {
            const cleanedMessages = this.messages.filter(message => message.content !== '');
            window.localStorage.setItem('chatHistory', JSON.stringify(cleanedMessages));
        },
    },
};
</script>


<style scoped>
.toggle-icon {
  display: none;
}
@media (max-width: 900px) {
  .toggle-icon {
    display: block;
  }
}
.custom-chat .vac-col-messages .vac-container-scroll {
  margin-top: 0px !important;
}
.typing-indicator {
  margin-left: 30px;
  display: flex;
  align-items: center;
}
.dot {
  width: 10px;
  height: 10px;
  margin: 0 3px;
  background-color: black;
  border-radius: 50%;
  animation: blink 1.4s infinite both;
}
.dot:nth-child(1) {
  animation-delay: 0s;
}
.dot:nth-child(2) {
  animation-delay: 0.2s;
}
.dot:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes blink {
  0% {
    opacity: 0.2;
  }
  20% {
    opacity: 1;
  }
  100% {
    opacity: 0.2;
  }
}

.custom-chat {
  height: 70vh;
  display: flex;
  flex-direction: column;
}

.gpt-message {
  background-color: #26384b;
  border-radius: 6px;
  color: #ececec;
  padding: 5px;
  margin-left: 30px;
  width: 100%;
}
.user-message {
  background-color: #e2e2e2;
  color: #26384b;
  border-radius: 10px;
  padding: 10px;
  margin-top: 5px;
}
.file-link {
  color: #fff;
}

.container-chat {
  height: 100%;
}
.vac-avatar {
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  height: 25px;
  width: 25px;
  min-height: 25px;
  min-width: 25px;
  border-radius: 50%;
}
.vac-avatar-container {
  color: #27374a;
  display: flex;
  flex-direction: row;
}
.vac-avatar-text {
  align-self: center;
  color: #27374a;
  margin-left:8px;
  font-weight: 500;
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.header {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 10px 0px 5px 0px;
  margin-top:-32px;
  background-color: #f9e1df;
  color: #000;
  font-size: 12px;
}
.header-container{
  width: 100%;
}
.bell-icon {
  color: #ee4135;
  margin-left:10px;
  font-size: 18px;
  margin-right:7px;
}
</style>
